import { ChakraProvider, Box, theme } from "@chakra-ui/react";
// import { ColorModeSwitcher } from "./ColorModeSwitcher"

import { useRoutes } from "react-router-dom";
import { Products } from "./pages/products";
import { Malls } from "./pages/malls";
import SidebarWithHeader from "./@core/components/navbar";
import { Dashboard } from "./pages/dashboard";
import { Retailers } from "./pages/retailers";
import { Services } from "./pages/services";
import { Stocks } from "./pages/stocks";
import { Stores } from "./pages/stores";

export function App() {
  const routes = [
    {
      path: "/",
      element: <Dashboard />, // Assuming you have a Home component
    },
    {
      path: "/products",
      element: <Products />,
    },
    {
      path: "/malls",
      element: <Malls />,
    },
    {
      path: "/retailers",
      element: <Retailers />, // Assuming you have a Retailers component
    },
    {
      path: "/services",
      element: <Services />, // Assuming you have a Services component
    },
    {
      path: "/stocks",
      element: <Stocks />, // Assuming you have a Stocks component
    },
    {
      path: "/stores",
      element: <Stores />, // Assuming you have a Stores component
    },
  ];

  const element = useRoutes(routes);
  return (
    <ChakraProvider theme={theme}>
      <Box textAlign="center" fontSize="xl">
        {/* <div style={{ display: "flex" }}>
          <div
            style={{
              padding: "10px",
              width: "40%",
              background: "#f0f0f0",
            }}
          >
            <ul style={{ listStyleType: "none", padding: 0 }}>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/products">Bubblegum</Link>
              </li>
              <li>
                <Link to="/malls">Shoelaces</Link>
              </li>
            </ul>
          </div>

          <div style={{ flex: 1, padding: "10px" }}>
            <Routes>
              {routes.map((route, index) => (
                // Render more <Route>s with the same paths as
                // above, but different components this time.
                <Route
                  key={index}
                  path={route.path}
                  // exact={route.exact}
                  element={route.element}
                />
              ))}
            </Routes>
          </div>
        </div> */}
        <SidebarWithHeader>{element}</SidebarWithHeader>
      </Box>
    </ChakraProvider>
  );
}
